import { AlertCircle, Check, X } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface VoteStatusBadgeProps {
  userVote: 'approved' | 'rejected' | undefined;
}

export function VoteStatusBadge(props: VoteStatusBadgeProps) {
  if (props.userVote === 'approved') {
    return (
      <Badge
        variant="default"
        className="bg-green-50 border-green-200 text-green-800 whitespace-nowrap shadow-none"
      >
        <Check className="h-3 w-3 mr-1" /> You approved
      </Badge>
    );
  }

  if (props.userVote === 'rejected') {
    return (
      <Badge
        variant="destructive"
        className="bg-red-50 border-red-200 text-red-800 whitespace-nowrap shadow-none"
      >
        <X className="h-3 w-3 mr-1" /> You rejected
      </Badge>
    );
  }

  return (
    <Badge
      variant="default"
      className="bg-orange-50 border-orange-200 text-orange-800 whitespace-nowrap shadow-none"
    >
      <AlertCircle className="h-3 w-3 mr-1" /> Your action required
    </Badge>
  );
}
